import { defineComponent as n, openBlock as r, createBlock as l, unref as i, mergeProps as p, withCtx as h, createElementVNode as t } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconListView2",
  __name: "IconListView2",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return (s, e) => (r(), l(i(m), p(o, { "view-box": "0 0 24 24" }), {
      default: h(() => [...e[0] || (e[0] = [
        t("path", { d: "M6.875 11a.75.75 0 0 1 .75-.75h8.75a.75.75 0 0 1 0 1.5h-8.75A.75.75 0 0 1 6.875 11m.75 2.25a.75.75 0 0 0 0 1.5h8.75a.75.75 0 0 0 0-1.5h-8.75m0 3a.75.75 0 0 0 0 1.5h8.75a.75.75 0 0 0 0-1.5h-8.75" }, null, -1),
        t("path", {
          "fill-rule": "evenodd",
          d: "M5.5 3.25A2.25 2.25 0 0 0 3.25 5.5v13a2.25 2.25 0 0 0 2.25 2.25h13a2.25 2.25 0 0 0 2.25-2.25v-13a2.25 2.25 0 0 0-2.25-2.25h-13M4.75 5.5A.75.75 0 0 1 5.5 4.75h13a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-.75.75h-13a.75.75 0 0 1-.75-.75v-13",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
